<template>
  <dropdown :align="align" dropdown-class="w-64 py-2 text-sm bg-white border rounded shadow-lg">
    <div class="w-full btn btn-secondary btn-sm">
      Sort <fa :icon="['far', 'sort-alt']" class="ml-1" />
    </div>
    <div slot="dropdown">
      <button v-for="option in options" :key="option.label" class="flex items-center w-full px-4 py-2 text-left hover:bg-gray-50" @click="sort(option.prop, option.dir)">
        <fa :icon="['far', 'check']" class="mr-2 text-indigo-500 opacity-0" :class="{ 'opacity-100': isActive(option) }" /> 
        <div v-html="option.label"></div>
      </button>
    </div>
  </dropdown>
</template>

<script>
export default {
  name: 'SortDropdown',

  props: {
    align: {
      type: String,
      default: 'left'
    },

    options: {
      type: Array
    }
  },

  methods: {
    isActive (option) {
      return this.$route.query.sort === option.prop && this.$route.query.dir === option.dir
    },

    sort (prop, dir) {
      this.$router.push({ 
        query: { 
          ...this.$route.query, 
          sort: prop,
          dir: dir 
        } 
      })
    }
  }
}
</script>